<div class="main-container">

  <div class="title">
    <span class="title-text">Devotee Utilities</span>
    <p class="small-title">Requisition history, confirmation SMS, and district search.</p>
  </div>

  <!-- CONFIRMATION SMS -->
  <div class="util-card">
    <div class="section-title">Confirmation SMS</div>
    <div class="inline-form">
      <input type="text" class="text-box-active" placeholder="Booking ID" [formControl]="smsBookingId" />
      <button type="button" class="ac-primary-btn" (click)="sendConfirmSms()">Send SMS</button>
    </div>
  </div>

  <!-- FC HISTORY -->
  <div class="util-card">
    <div class="section-title">FC requisition history</div>
    <div class="inline-form">
      <input type="text" class="text-box-active" placeholder="Family code" [formControl]="familyCode" />
      <button type="button" class="ac-primary-btn" (click)="searchFcHistory()">Search</button>
    </div>

    @for(bucket of bucketDefs; track bucket.key){
    @if(rows(bucket.key).length > 0){
    <div class="bucket">
      <div class="bucket-title">{{ bucket.label }} ({{ rows(bucket.key).length }})</div>
      <div class="table-container">
        <table class="table">
          <thead class="table-head">
            <tr>
              <th>Booking ID</th><th>Family Code</th><th>Category</th><th>Type</th>
              <th>Guests</th><th>From</th><th>To</th><th>Status</th><th>Stage</th>
            </tr>
          </thead>
          <tbody class="table-body">
            @for(row of rows(bucket.key); track row.requisitionId){
            <tr>
              <td>{{ row.requisitionId }}</td>
              <td>{{ row.familyCode }}</td>
              <td>{{ row.requisitionCategory || '-' }}</td>
              <td>{{ row.requisitionType || '-' }}</td>
              <td>{{ row.requisitionGuestCount }}</td>
              <td>{{ row.requisitionFromDate }}</td>
              <td>{{ row.requisitionToDate }}</td>
              <td>{{ row.requisitionStatus }}</td>
              <td>{{ row.requisitionLifecycleStatus }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    }
    }
    @if(fcSearched && !hasAnyBucket){
    <p class="empty">No requisition history for this family code.</p>
    }
  </div>

  <!-- DISTRICT SEARCH -->
  <div class="util-card">
    <div class="section-title">District search</div>
    <div class="inline-form">
      <input type="text" class="text-box-active" placeholder="District" [formControl]="district" />
      <input type="date" class="text-box-active" [formControl]="districtFrom" />
      <input type="date" class="text-box-active" [formControl]="districtTo" />
      <button type="button" class="ac-primary-btn" (click)="searchDistrict()">Search</button>
    </div>

    @if(districtResults.length){
    <div class="table-container">
      <table class="table">
        <thead class="table-head">
          <tr>
            <th>Booking ID</th><th>Family Code</th><th>Category</th><th>Type</th>
            <th>Guests</th><th>From</th><th>To</th><th>Status</th>
          </tr>
        </thead>
        <tbody class="table-body">
          @for(row of districtResults; track row.requisitionId){
          <tr>
            <td>{{ row.requisitionId }}</td>
            <td>{{ row.familyCode }}</td>
            <td>{{ row.requisitionCategory || '-' }}</td>
            <td>{{ row.requisitionType || '-' }}</td>
            <td>{{ row.requisitionGuestCount }}</td>
            <td>{{ row.requisitionFromDate }}</td>
            <td>{{ row.requisitionToDate }}</td>
            <td>{{ row.requisitionStatus }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
    @if(districtSearched && districtResults.length === 0){
    <p class="empty">No requisitions in this district and range.</p>
    }
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
